export const SET_VOICE_ENABLED = 'SET_VOICE_ENABLED';

export const setVoiceEnabled = voiceEnabled => ({
  type: SET_VOICE_ENABLED,
  value: {voiceEnabled},
});
